import { render } from "./VeiculoTrator.vue?vue&type=template&id=2d2d4968"
import script from "./VeiculoTrator.vue?vue&type=script&lang=ts"
export * from "./VeiculoTrator.vue?vue&type=script&lang=ts"
script.render = render

export default script